import React, { useMemo } from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import DashboardSharedTable from '@components/pages/Dashboard/Shared/DashboardSharedTable'
import type { RangeKey } from '@dataTypes/dashboard.types'
import type { OpenTreatmentOverviewResult } from '@services/api/dashboard/treatment.api'
import { isDashboardDevMocksEnabled } from '@utils/dashboardDevMocks.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import {
  getOpenTreatmentPatientsData,
  OPEN_TREATMENT_PATIENTS_COLUMNS,
} from '../dashboardOverview.mockData'
import { renderOverviewTableActionsCell } from './overviewTableActions'

type OpenTreatmentPatientsCardProps = {
  range: RangeKey
  data: OpenTreatmentOverviewResult | null
  loading: boolean
}

export function OpenTreatmentPatientsCard({
  range,
  data,
  loading,
}: OpenTreatmentPatientsCardProps): React.ReactElement {
  const useMocks = isDashboardDevMocksEnabled()
  const rows = useMemo(() => {
    if (data != null) return data.rows ?? []
    return useMocks ? getOpenTreatmentPatientsData(range) : []
  }, [data, range, useMocks])
  const isEmpty = shouldShowDashboardSectionEmpty(loading, rows.length > 0)
  const pending = isDashboardSectionPending(loading, data != null)

  return (
    <DashboardSectionCard
      title="Open treatment patients"
      titleHref="/dashboard/open-treatment-patients"
      className="dashboard-treatment-tables-card"
      loading={pending}
      skeleton={{ block: 'tall' }}
      isEmpty={isEmpty}
    >
      <DashboardSharedTable
        loading={pending ? false : loading}
        showSearchFilter={false}
        columns={OPEN_TREATMENT_PATIENTS_COLUMNS.map((col) =>
          col.key === 'actions'
            ? { ...col, formatter: renderOverviewTableActionsCell }
            : col,
        )}
        data={rows}
        showPagination={false}
      />
    </DashboardSectionCard>
  )
}
